import {createAction} from "redux-act";
import {OddsType} from "modules/constants/enums";

export const switchOddsType = createAction<OddsType>();
